import React, { useEffect, useState } from 'react';
import TextInput from "../TextInput";
import { Button } from "../Button";
import Result from "../Result";
import { formatNumber, parseNumber, postHeightToParent, toUsFormat, validInteger } from "../common-helpers";
import { calculate } from './helpers';
import './stimulus-check-second.css';

export const SecondStimulusCheck: React.FC = () => {
	const [filingSatus, setFilingSatus] = useState("single");
	const [dependents, setDependents] = useState("0");
	const [hasDependentsError, setHasDependentsError] = useState(false);
	const [income, setIncome] = useState("");
	const [hasIncomeError, setHasIncomeError] = useState(false);
	const [monthlyPayment, setMonthlyPayment] = useState("");
	const [hasResult, setHasResult] = useState(false);

	const filingStatusOptions = [
		{label: "Single", value: "single"},
		{label: "Married Filing Jointly", value: "married-jointly"},
		{label: "Married Filing Separately", value: "married-separately"},
		{label: "Head-of-Household", value: "head-houshold"},
		{label: "Qualifying Widow(er)", value: "widower"},
	];

	const onRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilingSatus(e.currentTarget.value);
  };
	const onDependentsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (hasDependentsError === true) { setHasDependentsError(false); }
    setDependents(validInteger(e.target.value));
  };
	const onIncomeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue: string = parseNumber(e.target.value).toString();

    if (inputValue === '') { setHasIncomeError(true); }
		else if (hasIncomeError === true) { setHasIncomeError(false); }

    setIncome(inputValue);
  };

	const onSubmit = () => {
		if (income === "") { setHasIncomeError(true); }
		else if (dependents === "") { setHasDependentsError(true); }
		else {
			const incomeInt = Number(income);
			const { monthlyPayment } = calculate(
				filingSatus,
				Number(dependents),
				incomeInt
			);
			setMonthlyPayment(toUsFormat(monthlyPayment));
			setHasResult(true);
		}
	};
	const onReset = () => {
		setFilingSatus("single");
		setDependents("0");
		setIncome("");
		setMonthlyPayment("");
		setHasResult(false);
	};

  useEffect(() => {
    postHeightToParent(document.body.scrollHeight);
  }, [hasDependentsError, hasIncomeError, hasResult]);

	return (
		<div className="container__stimulusCheck">
			<form>

				<div className="inputGroup">
					<div className="stimulusCheck-step">Step 1</div>
					<div className="stimulusCheck-question">What was your 2019 filing status?</div>
					<div className="stimulusCheck-tip"><i>Use information from your 2019 federal income tax return.</i></div>
					<fieldset id="filing-status">
						{filingStatusOptions && filingStatusOptions.map((option, i) => {
							return (
								<label className="stimulusCheck-input-radio-label" key={`stimulusCheck-radio-input-${i}`}>
									<input
										type="radio"
										name="filing-status"
										value={option.value}
										checked={filingSatus === option.value}
										onChange={onRadioChange}
										/> {option.label}
								</label>
							)
						})}
					</fieldset>
				</div>

				<div className="inputGroup">
					<div className="stimulusCheck-step">Step 2</div>
					<label htmlFor="dependents-input" className="stimulusCheck-question">Enter the number of children in your household who qualified for a child tax credit in 2019:</label>
					<div className="stimulusCheck-tip"><i>The child must be under 17.</i></div>
					<input
						id="dependents-input"
						type="text"
						pattern="/\d+/g"
						inputMode="numeric"
						name="dependents"
						value={dependents}
						className={hasDependentsError ? `stimulusCheck-input stimulusCheck-input_error` : `stimulusCheck-input`}
						onChange={onDependentsChange}
						required
					/>
					{hasDependentsError && (
						<p className="childTaxCredit-error">Please, enter number of dependents.</p>
					)}
				</div>

				<div className="inputGroup">
					<div className="stimulusCheck-step">Step 3</div>
					<label htmlFor="stimulusCheck-income-input" className="stimulusCheck-question">Enter your adjusted gross income from your 2019 tax return:</label>
					<TextInput
						id="stimulusCheck-income-input"
						name="income"
						inputMode="numeric"
						fieldClass={hasIncomeError ? `stimulusCheck-input stimulusCheck-input_error` : `stimulusCheck-input`}
						onChange={onIncomeChange}
						value={formatNumber(income)}
						data-testid="stimulusCheck-income"
					/>
					{hasIncomeError && (
						<p className="stimulusCheck-error">Please, enter correct sum.</p>
					)}
				</div>

				{hasResult && (
					<div className="stimulusCheck-result_container">
						<div className="stimulusCheck-result">Your estimated second stimulus check will be:<br/>
							<Result
								id="stimulusCheck-monthly-payment"
								result={monthlyPayment}
								classNames="stimulusCheck-result-value"
							/>
						</div>
					</div>
				)}
				<Button
				label="Submit"
				className="primary-button stimulusCheck-btn"
				onClickHandler={onSubmit}
				data-testid="stimulusCheck-calculate"
				/>
				<Button
					label="Clear Form"
					className="default-button stimulusCheck-btn"
					onClickHandler={onReset}
				/>
			</form>
		</div>
	);
}
